import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { SharedConfig } from '@takectrl-multiapp/svcs-share-config';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';
declare const dataLayer: unknown[];

@Component({
  selector: 'emergency-without-assistance-benefits',
  standalone: false,
  templateUrl: './emergency-without-assistance-benefits.component.html',
  styleUrls: ['./emergency-without-assistance-benefits.component.scss'],
})
export class EmergencyWithoutAssistanceBenefitsComponent implements OnInit {
  constructor(
    public sharedConfig: SharedConfig,
    public busnThirdPartyService: BUSNThirdPartyService,
    private readonly busnCommService: BUSNCommunicationService
  ) {}

  ngOnInit(): void {
    dataLayer.push({
      event: 'page_show',
      screenPath: 'emergency-without-assistance-benefits',
      screenName: 'emergency-without-assistance-benefits',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
  }

  async ngAfterViewInit(): Promise<void> {}

  showIntercom() {
    this.busnCommService.openContactCardPopup()
  }
}
